export const dictionaryListColumns = [
  {
    title: "字典值",
    width: 180,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "value"
  },
  {
    title: "字典Key",
    width: 140,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "key"
  },
  {
    title: "字典类型名",
    width: 320,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "typeName"
  },
  {
    title: "字典类型描述",
    width: 220,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "description"
  },
  {
    title: "创建日期",
    width: 180,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "insertTime"
    scopedSlots: { customRender: "insertTime" }
  },
  {
    title: "近期修改日期",
    width: 180,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "updateTime"
    scopedSlots: { customRender: "updateTime" }
  },
  {
    title: "操作",
    width: 88,
    fixed: "right",
    align: "center",
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]
